import {
    makeItemsListUrl,
    trans,
} from '@frontend/helpers'
import type {AdCategory} from '@frontend/modules/public/ads/AdsModuleTypes'
import {CategorySelectorDropdownMenuItems} from '@frontend/modules/public/ads/components/search/CategorySelectorDropdownMenuItems'
import {useItemsSearchCategorySelectedHandler} from '@frontend/modules/public/ads/components/search/hooks/useItemsSearchCategorySelectedHandler'
import {useAdsStore} from '@frontend/stores'
import {
    mdiChevronDown,
    mdiFolderMultipleOutline,
    mdiText,
} from '@mdi/js'
import {useState} from 'react'
import {Dropdown} from 'swayok-react-mdb-ui-kit/components/Dropdown/Dropdown'
import {DropdownItem} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownItem'
import {DropdownMenu} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownMenu'
import {DropdownToggle} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownToggle'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {toggleValueInArray} from 'swayok-react-mdb-ui-kit/helpers/form/toggleValueInArray'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'

interface CategorySelectorDropdownProps {
    iconMode?: boolean
}

// Компонент для выбора категории объявлений.
export function CategorySelectorDropdown(props: CategorySelectorDropdownProps) {

    const {
        iconMode,
    } = props

    const categories = useAdsStore(
        state => state.categories
    )

    const category = useAdsStore(
        state => state.searchPanelCategory
    )

    const onCategoryChange = useItemsSearchCategorySelectedHandler()

    // Раскрытые категории.
    const [
        expandedCategoryIds,
        setExpandedCategoryIds,
    ] = useState<number[]>([])

    // Открыть/закрыть меню подкатегорий.
    const onCategoryToggle = useEventCallback((category: AdCategory) => {
        setExpandedCategoryIds(
            expandedCategoryIds => toggleValueInArray(
                expandedCategoryIds,
                category.id
            )
        )
    })

    return (
        <div className={iconMode ? 'offered-items-filter-categories-icon' : ''}>
            <Dropdown
                focusFirstItemOnOpen={false}
                onOpenChange={nextShow => {
                    if (!nextShow) {
                        setExpandedCategoryIds([])
                    }
                }}
            >
                {iconMode ? (
                    <DropdownToggle
                        color="link"
                        className="with-icon-flex btn-offered-items-filter-category-selector"
                    >
                        <Icon
                            path={mdiFolderMultipleOutline}
                            color="primary"
                        />
                    </DropdownToggle>
                ) : (
                    <DropdownToggle
                        color="gray"
                        className="btn-offered-items-filter-category-selector"
                        outline
                        hasIcon
                    >
                        <Icon
                            path={mdiText}
                            className="me-0"
                        />
                        <span className="flex-1 ms-1 me-1 text-center">
                            {category ? category.name : trans().common.ads_filter.any_category}
                        </span>
                        <Icon path={mdiChevronDown} />
                    </DropdownToggle>
                )}

                <DropdownMenu
                    inline
                    offset={{
                        mainAxis: 6,
                    }}
                    shadow="2-strong"
                    id="btn-offered-items-filter-category-dropdown"
                >
                    {/* Опция: "Все категории" */}
                    <DropdownItem
                        key="category-all"
                        href={makeItemsListUrl(null)}
                        onClick={e => {
                            e.preventDefault()
                            onCategoryChange(null)
                        }}
                    >
                        {trans().common.ads_filter.any_category}
                    </DropdownItem>
                    <CategorySelectorDropdownMenuItems
                        categories={categories}
                        onCategoryChange={onCategoryChange}
                        expandedCategoryIds={expandedCategoryIds}
                        onCategoryToggle={onCategoryToggle}
                    />
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}

